import { FC } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import ImageComponentRender from './ImageComponentRender';
import { UploadStatus } from '../../extensions/CustomImage';

interface ImageNodeAttrs {
  src: string;
  alt?: string;
  title?: string;
  id?: string;
  uploadStatus?: UploadStatus;
  progress?: number;
}

const ImageDynamicDisplay: FC<NodeViewProps> = ({ node, deleteNode }) => {
  const attrs = node.attrs as ImageNodeAttrs;

  const handleRemove = () => {
    deleteNode();
  };

  return (
    <NodeViewWrapper as="div" className="custom-image-wrapper">
      <ImageComponentRender
        id={attrs.id}
        src={attrs.src}
        alt={attrs.alt}
        uploadStatus={attrs.uploadStatus}
        progress={attrs.progress}
        isDynamic
        onRemove={handleRemove}
        onDelete={handleRemove}
      />
    </NodeViewWrapper>
  );
};

export default ImageDynamicDisplay;